import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { Labels, copyRight } from '../../common/app-enums-es';

export const footerValues = {
  phoneNumber: '7777-7777',
  address: 'San Rafaél Norte, Pérez Zeledón',
  contactEmail: 'dudas@aromasymas.com',
};

export const Footer: FC = () => {
  return (
    <Box sx={{ backgroundColor: '#1976d2' }} color="white">
      <Stack direction="row" position="relative" minHeight="7rem" padding="3rem 3rem 1rem">
        <Stack zIndex={2} spacing={2}>
          <Stack spacing={0.75}>
            <Typography sx={{ fontWeight: 'bold' }}>{Labels.contactUs}</Typography>
            <Stack direction="row">
              <Stack paddingLeft={1}>
                <Typography>{Labels.phone}:</Typography>
                <Typography>{Labels.address}:</Typography>
                <Typography>{Labels.email}:</Typography>
              </Stack>
              <Stack paddingLeft={1}>
                <Typography>{footerValues.phoneNumber}</Typography>
                <Typography>{footerValues.address}</Typography>
                <Typography>{footerValues.contactEmail}</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Stack>
        <Box width="fit-content" alignSelf="center" padding="1rem 1rem">
          <Typography>{copyRight()}</Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default Footer;
